var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showDialog
    ? _c(
        "modal",
        {
          attrs: {
            title: _vm.$t("edit-sip-user"),
            width: "400",
            type: "question",
            "confirm-text": _vm.$t("save"),
            "cancel-text": _vm.$t("cancel"),
            "is-cta-disable": _vm.isCtaDisable,
            "confirm-loading": _vm.loading,
            "show-save-icon": true,
            persistent: "",
            "content-class": "devops-subdialog",
            "show-close-button": "",
          },
          on: {
            cancel: function ($event) {
              _vm.showDialog = false
            },
            confirm: _vm.handleSubmit,
          },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _c(
            "v-form",
            {
              ref: "form",
              staticClass: "px-4",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.handleSubmit.apply(null, arguments)
                },
              },
              model: {
                value: _vm.validForm,
                callback: function ($$v) {
                  _vm.validForm = $$v
                },
                expression: "validForm",
              },
            },
            [
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("v-text-field", {
                    attrs: {
                      rules: [
                        _vm.rules.required(_vm.displayName, "displayName"),
                        _vm.rules.minLength(_vm.displayName),
                        _vm.rules.maxLength(_vm.displayName),
                      ],
                      dense: "",
                      outlined: "",
                      "background-color": "light-primary",
                      label: _vm.$t("display-name-required"),
                    },
                    model: {
                      value: _vm.displayName,
                      callback: function ($$v) {
                        _vm.displayName = $$v
                      },
                      expression: "displayName",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      rules: _vm.password?.length
                        ? [_vm.rules.passwordFormat(_vm.password)]
                        : [],
                      dense: "",
                      outlined: "",
                      "background-color": "light-primary",
                      label: _vm.$t("sip-password"),
                      hint: _vm.$t("sip-password-hint"),
                      "persistent-hint": "",
                      "append-icon": _vm.showPassword
                        ? "mdi-eye"
                        : "mdi-eye-off",
                      type: _vm.showPassword ? "text" : "password",
                    },
                    on: {
                      "click:append": function ($event) {
                        _vm.showPassword = !_vm.showPassword
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "message",
                          fn: function ({ message }) {
                            return [
                              _c("span", [_vm._v(_vm._s(message))]),
                              _vm.password?.length
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-block red--text font-weight-bold mt-1",
                                    },
                                    [
                                      _vm._v(
                                        " ⚠️ " +
                                          _vm._s(
                                            _vm.$t("sip-password-warning")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1844337775
                    ),
                    model: {
                      value: _vm.password,
                      callback: function ($$v) {
                        _vm.password = $$v
                      },
                      expression: "password",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "grey lighten-4 rounded pa-3 mt-4 mb-2" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-caption text--secondary text-center mb-2",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("sip-advanced-settings-hint")) +
                              " "
                          ),
                        ]
                      ),
                      _c("v-switch", {
                        staticClass: "mt-0 mb-0",
                        attrs: {
                          label: _vm.$t("sip-private-recording"),
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.privateRecording,
                          callback: function ($$v) {
                            _vm.privateRecording = $$v
                          },
                          expression: "privateRecording",
                        },
                      }),
                      _c("v-select", {
                        staticClass: "mt-4",
                        attrs: {
                          items: _vm.groupItems,
                          label: _vm.$t("sip-default-group"),
                          hint: _vm.$t("sip-default-group-hint"),
                          "persistent-hint": "",
                          dense: "",
                          outlined: "",
                          "background-color": "white",
                          clearable: "",
                          "no-data-text": _vm.$t("no-groups-available"),
                        },
                        model: {
                          value: _vm.defaultUserGroupId,
                          callback: function ($$v) {
                            _vm.defaultUserGroupId = $$v
                          },
                          expression: "defaultUserGroupId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }